export function mapLegacyWeightValue(value: string | readonly string[] | number | undefined) {
  switch (value) {
    case 'bold':
      return 700
    case 'light':
      return 300
    case 'regular':
      return 400
    case 400:
      return value
    default:
      return Number.parseInt(value as string) || 400
  }
}
export default function buildGoogleWebfontUrl(fontFamily = '', fontWeight?: (number | string)[]) {
  if (!fontFamily) return

  // For the GoogleFonts Api, we need fontWeight as number.
  // This takes care of possible legacy values out there.
  const weights = (fontWeight ?? [400]).map(mapLegacyWeightValue).sort((a, b) => a - b)
  const fontFamilyForUrl = `?family=${fontFamily.replace(/ /g, '+')}`
  const fontWeightForUrl = fontWeight ? `:wght@${weights.join(';')}` : ''

  return `https://fonts.googleapis.com/css2${fontFamilyForUrl}${fontWeightForUrl}`
}
